/**
 * Laden aller Standard-Hilfsfunktionen
 */

import scrollToErrors from './utils/scroll-to-errors';
import initResponsiveTables from './utils/responsive-tables';
import initJsBackButton from './utils/js-back-button';

export default function initAllUtils() {
  scrollToErrors();
  initResponsiveTables();
  initJsBackButton();
}
